export default {"src":"/_next/static/media/goat-spins-banner-3-desk.15087799.svg","height":656,"width":1781,"blurWidth":0,"blurHeight":0};